/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_ArrivalInputs */

const en_cargos_arrival = /** @type {(inputs: Cargos_ArrivalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrival`)
};

const es_cargos_arrival = /** @type {(inputs: Cargos_ArrivalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Llegada`)
};

/**
* | output |
* | --- |
* | "Arrival" |
*
* @param {Cargos_ArrivalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_arrival = /** @type {((inputs?: Cargos_ArrivalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_ArrivalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_arrival(inputs)
	return es_cargos_arrival(inputs)
});